import React from 'react';

const CURRENT_YEAR = new Date().getFullYear();

const Copyright = () => {
    return (
        <p style={{ paddingTop: '2rem' }}>
            Copyright © {CURRENT_YEAR} Loan.co.uk. All rights reserved.
        </p>
    );
};

export default Copyright;
